import { useMemo } from 'react'

import type { EditorThemeClasses } from 'lexical'

import { useBaseStyles } from './style'

export const useBaseTheme = (): EditorThemeClasses => {
  const { cx, styles } = useBaseStyles()

  return useMemo(
    () => ({
      embedBlock: {
        base: cx(styles.embedBlock, 'editor-embed-block-base'),
        focus: cx(styles.embedBlockFocus, 'editor-embed-block-focus')
      },
      heading: {
        h1: cx(styles.h1, 'editor-heading-h1'),
        h2: cx(styles.h2, 'editor-heading-h2'),
        h3: cx(styles.h3, 'editor-heading-h3'),
        h4: cx(styles.h4, 'editor-heading-h4')
      },
      link: cx(styles.link, 'editor-link'),
      image: cx(styles.image, 'editor-image'),
      attachment: cx(styles.attachment, 'editor-attachment'),
      emoji: cx(styles.emoji, 'editor-emoji'),
      filler: cx(styles.filler, 'editor-filler'),
      list: {
        listitem: cx(styles.listItem, 'editor-list-item'),
        nested: {
          listitem: cx(styles.listItemNested, 'editor-list-item-nested')
        },
        olDepth: [
          cx(styles.ol1, 'editor-ol-depth-1'),
          cx(styles.ol2, 'editor-ol-depth-2'),
          cx(styles.ol3, 'editor-ol-depth-3'),
          cx(styles.ol1, 'editor-ol-depth-4'),
          cx(styles.ol2, 'editor-ol-depth-5'),
          cx(styles.ol3, 'editor-ol-depth-6')
        ],
        ul: cx(styles.ul, 'editor-ul')
      },
      ltr: cx(styles.ltr, 'editor-ltr'),
      rtl: cx(styles.rtl, 'editor-rtl'),
      paragraph: cx(styles.paragraph, 'editor-paragraph'),
      quote: cx(styles.quote, 'editor-quote'),
      tableWrapper: cx(styles.tableWrapper, 'editor-table-wrapper'),
      // tableScrollableWrapper: cx(
      //   styles.tableScrollableWrapper,
      //   'editor-table-scrollable-wrapper'
      // ),
      tableController: cx(styles.tableController, 'editor-table-controller'),
      table: cx(styles.table, 'editor-table'),
      // className 不能修改，TableCellResizerPlugin 中用到了
      // 如果后期包裹了 StyleProvider 要注意 prefix 对静态 className 的影响
      tableCell: cx(styles.tableCell, 'editor-table-cell'),
      tableCellHeader: cx(styles.tableCellHeader, 'editor-table-cell-header'),
      tableCellMarked: cx(styles.tableCellMarked, 'editor-table-cell-marked'),
      tableCellSelected: cx(
        styles.tableCellSelected,
        'editor-table-cell-selected'
      ),
      tableSelection: 'table-selection',
      text: {
        base: 'editor-text-base',
        bold: cx(styles.textBold, 'editor-text-bold'),
        code: 'editor-text-code',
        italic: cx(styles.textItalic, 'editor-text-italic'),
        strikethrough: cx(
          styles.textStrikethrough,
          'editor-text-strikethrough'
        ),
        subscript: cx(styles.textSubscript, 'editor-text-subscript'),
        superscript: cx(styles.textSuperscript, 'editor-text-superscript'),
        underline: cx(styles.textUnderline, 'editor-text-underline'),
        underlineStrikethrough: cx(
          styles.textUnderlineStrikethrough,
          'editor-text-underline-strikethrough'
        )
      }
    }),
    [cx, styles]
  )
}
